import {
    DELETEBUSINESSNATUREMAPPING_SUCCESS,
    DELETEBUSINESSNATUREMAPPING_FAILED,
    RESET_DELETEBUSINESSNATUREMAPPING,
    LOADING_DELETEBUSINESSNATUREMAPPING,
    NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetDeleteBusinessNatureMapping = () => {
    return { type: RESET_DELETEBUSINESSNATUREMAPPING };
};

const deleteBusinessNatureMapping =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_DELETEBUSINESSNATUREMAPPING });
        await adminServices
            .post("deleteBusinessNatureMapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        dispatch(deleteBusinessNatureMappingsuccess(res.data));
                        break;
                    default:
                        dispatch(deleteBusinessNatureMappingFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_DELETEBUSINESSNATUREMAPPING,
                    payload: err,
                });
            });
    };
function deleteBusinessNatureMappingsuccess(data) {
    return {
        type: DELETEBUSINESSNATUREMAPPING_SUCCESS,
        payload: data,
    };
}
function deleteBusinessNatureMappingFailed(data) {
    return {
        type: DELETEBUSINESSNATUREMAPPING_FAILED,
        payload: data,
    };
}

export { resetDeleteBusinessNatureMapping, deleteBusinessNatureMapping };
